import { __r } from 'react-i18n';
import { prop, getSymbolFromCurrency } from '../../../utilities';

export enum cartRoutes {
  INDEX = 'routes:kosik',
  SECOND_STEP = 'routes:kosik/osobne-udaje',
  THIRD_STEP = 'routes:cart/dodanie-a-platba',
}

export const cartIndexRoute = __r('routes:kosik', '/kosik');
export const cartSecondStepRoute = __r(
  'routes:kosik/osobne-udaje',
  '/kosik/osobne-udaje',
);
export const cartThirdStepRoute = __r(
  'routes:cart/dodanie-a-platba',
  '/kosik/dodanie-a-platba',
);

export const remapDeliveryItem = (
  item: any,
): { id: number; name: string; price: string } => {
  const currency = prop(item, 'price.currency', 'EUR');
  const price = prop(item, 'price.price', 0);
  const priceReadable =
    price > 0 ? `${price} ${getSymbolFromCurrency(currency)}` : 'Zadarmo';

  return {
    ...item,
    id: item.delivery_id,
    name: item.delivery_name,
    price: priceReadable,
  };
};

export const remapPaymentItem = (
  item: any,
): {
  id: number;
  name: string;
  price: string;
  isFree: boolean;
  icons: string[];
} => {
  const currency = prop(item, 'price.currency', 'EUR');
  const price = prop(item, 'price.price', 0);
  let icons: string[] = [];

  if (item.payment_id === 'CARDPAY') {
    icons = [
      '/images/cart/payments/cardpay/logo_DC.jpg',
      '/images/cart/payments/cardpay/logo_discover.jpg',
      '/images/cart/payments/cardpay/logo_maestro.gif',
      '/images/cart/payments/cardpay/logo_mc.gif',
      '/images/cart/payments/cardpay/logo_visa_electron.gif',
      '/images/cart/payments/cardpay/logo_visa.gif',
    ];
  } else if (item.payment_id === 'BESTERON_UNIPAY') {
    icons = ['/images/cart/payments/besteron/unicredit.svg'];
  } else if (item.payment_id === 'BESTERON_SPORO') {
    icons = ['/images/cart/payments/besteron/slovenska.svg'];
  } else if (item.payment_id === 'BESTERON_TATRA') {
    icons = ['/images/cart/payments/besteron/tatra.svg'];
  } else if (item.payment_id === 'BESTERON_VUBPAY') {
    icons = ['/images/cart/payments/besteron/vub.svg'];
  } else if (item.payment_id === 'BESTERON_POSTA') {
    icons = ['/images/cart/payments/besteron/postova.svg'];
  } else if (item.payment_id === 'BESTERON_VIAMO') {
    icons = ['/images/cart/payments/besteron/viamo.svg'];
  }

  const priceReadable =
    price > 0 ? `${price} ${getSymbolFromCurrency(currency)}` : 'Zadarmo';
  return {
    id: item.payment_id,
    name: item.payment_name,
    price: priceReadable,
    isFree: !(price > 0),
    icons,
  };
};
